/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import PreOpAnaesthesiaChart from './pre-op-anaesthesia-chart';
import PreOpAnaesthesiaChartDetail from './pre-op-anaesthesia-chart-detail';
import PreOpAnaesthesiaChartUpdate from './pre-op-anaesthesia-chart-update';
import PreOpAnaesthesiaChartDeleteDialog from './pre-op-anaesthesia-chart-delete-dialog';

const PreOpAnaesthesiaChartRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<PreOpAnaesthesiaChart />} />
    <Route path="new" element={<PreOpAnaesthesiaChartUpdate />} />
    <Route path=":id">
      <Route index element={<PreOpAnaesthesiaChartDetail />} />
      <Route path="edit" element={<PreOpAnaesthesiaChartUpdate />} />
      <Route path="delete" element={<PreOpAnaesthesiaChartDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default PreOpAnaesthesiaChartRoutes;
